import React, { useState, useEffect } from "react";
import NumberBox from 'devextreme-react/number-box';
import { Navigate } from "react-router-dom";
import { TextBox } from "devextreme-react";

function LVNumberBoxDocumento({ IdTipo, IdTipoMovimiento, DatosDocumento, SetDatosDocumento, NumeracionLibre = false }) {

  const [codigoPuntoVentaFormateado, setCodigoPuntoVentaFormateado] = useState();
  const [numeroFormateado, setNumeroFormateado] = useState(DatosDocumento.numero || "00000000");
  const { ABM_IMP_PuntosFiscales: { function_ABM_IMP_PuntosFiscales_ObtenerProximoNumeroPorCodigoPuntoFiscal } } = require('neftis7_apicaller');

  const handleOnValueChanged_PuntoVenta = async (e) => {
    const nuevoCodigoPuntoVenta = parseInt(e.value).toString().padStart(4, '0');
    setCodigoPuntoVentaFormateado(nuevoCodigoPuntoVenta);

    if (NumeracionLibre) {
      SetDatosDocumento(prevDatos => ({
        ...prevDatos,
        codigoPuntoVenta: parseInt(e.value).toString().padStart(4, '0'),
        codigoPuntoVentaFormateado: nuevoCodigoPuntoVenta,
        numero: 0,
        numeroFormateado: "00000000",
        numeroFantasia: `${nuevoCodigoPuntoVenta}-00000000`
      }));
    }
    else {
      if (/^\d+$/.test(e.value) && IdTipo !== 0 && IdTipoMovimiento !== 0) {
        try {
          const resultPV = await function_ABM_IMP_PuntosFiscales_ObtenerProximoNumeroPorCodigoPuntoFiscal(parseInt(e.value), IdTipo, IdTipoMovimiento);
          const nuevoNumero = resultPV?.data?.Numero ? parseInt(resultPV.data.Numero).toString().padStart(8, '0') : "00000001";
          setNumeroFormateado(nuevoNumero);

          SetDatosDocumento(prevDatos => ({
            ...prevDatos,
            codigoPuntoVenta: parseInt(nuevoCodigoPuntoVenta),
            codigoPuntoVentaFormateado: nuevoCodigoPuntoVenta,
            numero: parseInt(nuevoNumero),
            numeroFormateado: nuevoNumero,
            numeroFantasia: `${nuevoCodigoPuntoVenta}-${nuevoNumero}`
          }));
        } catch (error) {
          setNumeroFormateado("00000000");
        }
      } else {
        setNumeroFormateado("00000000");
        SetDatosDocumento(prevDatos => ({
          ...prevDatos,
          codigoPuntoVenta: 0,
          codigoPuntoVentaFormateado: "0000",
          numero: 0,
          numeroFormateado: "00000000",
          numeroFantasia: "0000-00000000"
        }));
      }
    }
  };

  const handleOnValueChanged_Numero = (e) => {
    const nuevoNumero = parseInt(e.value).toString().padStart(8, '0');
    setNumeroFormateado(nuevoNumero);

    SetDatosDocumento(prevDatos => ({
      ...prevDatos,
      numero: parseInt(nuevoNumero),
      numeroFormateado: nuevoNumero,
      numeroFantasia: `${codigoPuntoVentaFormateado}-${nuevoNumero}`
    }));
  };

  useEffect(() => {
    if (DatosDocumento.codigoPuntoVentaFormateado != codigoPuntoVentaFormateado) {
      setCodigoPuntoVentaFormateado(DatosDocumento.codigoPuntoVentaFormateado || "0000");
    }
    if (DatosDocumento.numeroFormateado != numeroFormateado) {
      setNumeroFormateado(DatosDocumento.numeroFormateado || "00000000");
    }
  }, [DatosDocumento]);

  return (
    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', gap: '5px', minWidth: '220px' }} >

      Nº
      <TextBox
        value={codigoPuntoVentaFormateado}
        onValueChanged={handleOnValueChanged_PuntoVenta}
        mask={NumeracionLibre ? "" : "0000"} 
        width={85}
      />

      <div style={{ width: '5px' }}>-</div>

      <TextBox
        value={numeroFormateado}
        onValueChanged={handleOnValueChanged_Numero}
        mask={NumeracionLibre ? "" : "00000000"} 
        width={115}
      />

    </div>
  );
}

export default LVNumberBoxDocumento